import ClassNames from "classnames";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import { clearTokenFromLocalStorage, getLocalValue } from "../../utils/auth";

import Button from "../../components/Button";
import SecurityQuestionsForm from "../../components/SetSecurityQuestion/index";

import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import TDCXLogo from "../../components/_Icons/TDCXLogo";

import { getLoginUrl } from "../../helpers/loginHelper";
import getUserIP, { formatIPJSON } from "../../utils/getUserIP";
import styles from "../auth/Login.module.scss";

export default function SetSecurityQuestion() {
  const { t } = useTranslation();
  const history = useHistory();
  const { addNotification } = useNotification();

  const [answers, setAnswers] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!isValid) {
      addNotification(t("setSecurityQuestion.pleaseComplete"), "error");
      return;
    }

    try {
      setLoading(true);
      const userIp = await getUserIP();
      await apiRequest.post("/api/security-questions", {
        answers,
        userIp: formatIPJSON(userIp)
      });
      localStorage.setItem("has_completed_security_questions", "1");
      addNotification(t("setSecurityQuestion.saved"), "success");
      setTimeout(() => {
        const url = getLoginUrl(
          parseInt(getLocalValue("u_coaching_role")),
          false,
          true
        );
        window.location.replace(url);
      }, 800);
    } catch (err) {
      addNotification(t("setSecurityQuestion.failed"), "error");
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = (e) => {
    e.preventDefault();
    clearTokenFromLocalStorage();
    history.push("/");
  };

  const isDisabled = !isValid || loading;

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.loginBlock}>
        {/* LOGO */}
        <div className={styles.logo}>
          <FlashCoachLogo />
        </div>

        {/* FORM */}
        <div className={styles.loginContent}>
          {/* HEADER */}
          <div className={styles.loginContent__formControl}>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontWeight: 600,
                  color: "#666",
                  fontSize: 20,
                }}
              >
                {t("setSecurityQuestion.title")}
              </div>

              <div
                style={{
                  color: "#777",
                  marginTop: 20,
                  fontSize: 14,
                }}
              >
                {t("setSecurityQuestion.subtitle")}
              </div>
            </div>
          </div>

          {/* FORM */}
          <div className={styles.loginContent__formControl}>
            <SecurityQuestionsForm
              onChange={setAnswers}
              onValidityChange={setIsValid}
            />
          </div>

          {/* BUTTON */}
          <div
            className={ClassNames(
              styles.loginContent__formControl,
              styles.loginContent__submitBtnWrapper
            )}
          >
            <Button
              variant="contained"
              fullWidth
              isloading={loading ? 1 : 0}
              disabled={isDisabled}
              onClick={handleSubmit}
              style={{
                backgroundColor: isDisabled ? "#d6d6d6" : "#f5b019",
                color: isDisabled ? "#888" : "#fff",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
            >
              {t("setSecurityQuestion.continue")}
            </Button>
          </div>

          {/* BACK TO LOGIN */}
          <div className={styles.loginContent__formControl}>
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <Link
                to="/"
                onClick={handleBackToLogin}
                className={styles.backLink}
              >
                {t("setSecurityQuestion.backToLogin")}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className={styles.footer}>
        <div className={styles.logo}>
          <TDCXLogo width={100} />
        </div>
        <div className={styles.copyright}>
          {t("common.copyright")}
        </div>
      </div>
    </div>
  );
}